import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-country-list',
  templateUrl: './country-list.component.html',
  styleUrls: ['./country-list.component.scss']
})
export class CountryListComponent implements OnInit {

  public menus = [];
  public selected = [];
  CountryList;
  isLoading;
  isDeleting;
  DeletingItem;

  constructor(private router: Router, private http: HttpClient, private toastr: ToastrService, private modalService: NgbModal,private TokenService: TokenService) {
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['CountryDefinitions']) {
      router.navigateByUrl('/');
    }
  }


  ngOnInit() {
    this.GetCountryList();
  }

  GetCountryList() {
    this.http.get<any>(environment.url + 'Country/CountryList').subscribe(data => {
      this.CountryList = data;
      this.isLoading = true;
    });
  }
  gotoCountryEdit(item: any) {
    const navigatioExtra: NavigationExtras = {
      queryParams: { id: item }
    }
    this.router.navigate(['/home/definitions/edit-country'], navigatioExtra);
  }
  
  DeleteCountry() {
    this.isDeleting = true;
    var body = { Ref : this.DeletingItem };
    this.http.post<any>(environment.url + 'Country/DeleteCountry', body).subscribe(data => {
      this.isDeleting = false;
      this.DeletingItem = "";
      this.GetCountryList();
      if (!data.Error) {
        this.modalService.dismissAll();
        this.toastr.success("Ülke Silindi", '', {
          timeOut: 3000,
        });
      }
      else {
        this.toastr.error("Ülke Silinemedi", 'Hata !', {
          timeOut: 3000,
        });
      }
    });
  }

  DeleteCountryModal(file,ref) {
    this.DeletingItem = ref;
    this.modalService.open(file, { centered: true });
  }
  CloseDeleteModalClose(){
    this.modalService.dismissAll();
    this.DeletingItem = "";
  }
}
